import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useRef, useState } from "react";
import ShurikenProgress from "../../../../../../../../../shared/Animations/ShurikenProgress";
import {
    RelatedUser,
    User,
    UserForRanking,
} from "../../../../../../../../../shared/User/types";
import { Tab } from "../../types";
import { fetchUsersForRanking } from "../fetchUsersForRanking";
import { RequestRecord } from "./RequestRecord";

export function RequestsTab({
    requestedUsers,
    user,
    setCurrentTab,
}: {
    requestedUsers: RelatedUser[];
    user: User;
    setCurrentTab: (tab: Tab) => void;
}) {
    const [friendsForRanking, setFriendsForRanking] = useState<
        UserForRanking[] | "loading"
    >("loading");

    const userIds = requestedUsers.map(f => f.userId);
    useEffect(() => {
        fetchUsersForRanking(userIds).then(u => {
            setFriendsForRanking(u);
        });
    }, [requestedUsers]);

    const _friendsForRanking =
        friendsForRanking === "loading"
            ? "loading"
            : friendsForRanking.filter(f => userIds.includes(f.userId)); // Filter to remove record immediately when it's approved

    return (
        <RequestList
            requestedUsers={_friendsForRanking}
            user={user}
            setCurrentTab={setCurrentTab}
        />
    );
}

function RequestList({
    requestedUsers,
    user,
    setCurrentTab,
}: {
    requestedUsers: UserForRanking[] | "loading";
    user: User;
    setCurrentTab: (tab: Tab) => void;
}) {
    const c = useStyles();
    const scrollableContainerRef = useRef<HTMLDivElement>(null);

    const isLoading = requestedUsers === "loading";

    const hasRequest = !isLoading && requestedUsers.length > 0;
    const [hadRequestOnce, setHadRequestOnce] = useState(false);
    useEffect(() => {
        if (isLoading) {
            return;
        }
        if (hasRequest) {
            setHadRequestOnce(true); // Prevent to change tab after the first render
            return;
        }
        if (!hadRequestOnce) {
            return;
        }
        // Change the tab after the last Friend Request is approved or deleted
        setCurrentTab(Tab.friends);
    }, [isLoading, hasRequest, setCurrentTab]);

    return (
        <div className={c.container} ref={scrollableContainerRef}>
            {isLoading && (
                <ShurikenProgress size="10%" style={{ marginTop: 30 }} />
            )}
            <Collapse in={!isLoading} timeout={500}>
                {!isLoading &&
                    requestedUsers.map((friend, i) => (
                        <RequestRecord
                            key={friend.userId}
                            friend={friend}
                            colorNumber={i + 1}
                            user={user}
                            scrollableContainerEl={
                                scrollableContainerRef.current
                            }
                        />
                    ))}
                {!isLoading && requestedUsers.length === 0 && (
                    <div className={c.noData}>No Data</div>
                )}
            </Collapse>
        </div>
    );
}
const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.grey[100],
        height: 308,
        maxHeight: 308,
        flex: 1,
        fontSize: "large",
        overflowY: "auto",
        overflowX: "hidden",
        position: "relative",
    },
    noData: {
        width: "100%",
        height: 305,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.grey[600],
    },
}));
